// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import "trix"
import "@rails/actiontext"

import "@github/relative-time-element"

// PWA: lets phones install Veci on the home screen (app/views/pwa/service-worker.js)
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/service-worker.js", { scope: "/" })
}
// Chrome offers installing once per page load, often before any Stimulus
// controller connects: keep the offer for install_controller.js.
window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault()
  window.veciInstallPrompt = event
  document.dispatchEvent(new CustomEvent("veci:installable"))
})

Turbo.setConfirmMethod((message, element) => {
  console.log(message, element)
  let dialog = document.getElementById("turbo-confirm")
  dialog.querySelector("p").textContent = message
  dialog.showModal()

  return new Promise((resolve, reject) => {
    dialog.addEventListener("close", () => {
      resolve(dialog.returnValue == "confirm")
    }, { once: true })
  })
})
